import { render } from "./v-loading.vue?vue&type=template&id=574101dc&scoped=true"
import script from "./v-loading.vue?vue&type=script&lang=js"
export * from "./v-loading.vue?vue&type=script&lang=js"

import "./v-loading.vue?vue&type=style&index=0&id=574101dc&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574101dc"]])

export default __exports__